module.exports = __webpack_public_path__ + "media/referral/squiggly-b4db635d.svg";